import { Provider } from '@angular/core';
import { provideMockKeycloak, MockKeycloakOptions } from './mock-keycloak.provider';
import { AuthService } from '../auth.service';
import { UserService } from '../user.service';

export function provideAuthTesting(options: MockKeycloakOptions = {}): Provider[] {
  return [
    provideMockKeycloak(options),
    AuthService,
    UserService
  ];
}

export {
  createMockKeycloak,
  provideMockKeycloak,
  mockKeycloakAuthenticated,
  mockKeycloakUnauthenticated,
  mockKeycloakAdmin,
  mockKeycloakCover3DTenant,
  mockKeycloakTrybaTenant,
  type MockKeycloakOptions
} from './mock-keycloak.provider';
